import React from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  Grid,
  TextField,
} from "@material-ui/core";
import { Send } from "@material-ui/icons";
import axios from "axios";
import "./Contact.css";

export default function ContactForm() {
  const history = useHistory();
  const [value, setValue] = React.useState("emailme");

  const initializeForm = () => {
    document.getElementById("email").setAttribute("required", "");
    document.getElementById("number").removeAttribute("required");
  };

  window.onload = initializeForm;

  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value === "emailme") {
      document.getElementById("email").setAttribute("required", "");
      document.getElementById("number").removeAttribute("required");
    } else {
      document.getElementById("email").removeAttribute("required");
      document.getElementById("number").setAttribute("required", "");
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const firstName = document.getElementById("firstname").value;
    const lastName = document.getElementById("lastname").value;
    const email = document.getElementById("email").value;
    const number = document.getElementById("number").value;
    const subject = document.getElementById("subject").value;
    const message = document.getElementById("message").value;
    const method = document.querySelector('input[name="method"]:checked').value;

    axios({
      method: "POST",
      url: "https://formspree.io/xpzyvgnd",
      data: { firstName, lastName, number, email, subject, message, method },
    });
    document.getElementById("contact-form").reset();
    history.replace("/submit");
  };

  return (
    <section id="contact" className="pc-section papercraft pc-section--alt">
      <header className="pc-section__head">
        <span className="pc-eyebrow">Say hello</span>
        <h2 className="pc-section__title">
          Get in <em style={{ fontStyle: "italic", color: "var(--pc-terracotta)" }}>touch</em>.
        </h2>
        <p className="pc-section__lede">
          Questions, custom requests, or just curious? Send a note — we read every one.
        </p>
      </header>

      <form
        autoCorrect="off"
        onSubmit={handleSubmit}
        id="contact-form"
        className="pc-contact"
      >
        <div className="form-row">
          <div className="col">
            <TextField required label="First Name" type="text" margin="normal" variant="outlined" id="firstname" placeholder="First Name" style={{ width: "100%" }} />
          </div>
          <div className="col">
            <TextField required label="Last Name"  type="text" margin="normal" variant="outlined" id="lastname"  placeholder="Last Name"  style={{ width: "100%" }} />
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", paddingTop: "0.5rem", marginTop: "0.5rem" }}>
          <FormLabel component="legend">How should we reach you?</FormLabel>
          <RadioGroup name="method" value={value}>
            <Grid container justifyContent="center">
              <Grid item><FormControlLabel value="emailme" control={<Radio />} label="Email"  onClick={handleChange} /></Grid>
              <Grid item><FormControlLabel value="callme"  control={<Radio />} label="Call"   onClick={handleChange} /></Grid>
              <Grid item><FormControlLabel value="textme"  control={<Radio />} label="Text"   onClick={handleChange} /></Grid>
            </Grid>
          </RadioGroup>
        </div>

        <div className="form-row">
          <div className="form-group col-md">
            <TextField label="Email Address" type="email" id="email"  variant="outlined" placeholder="Email Address" style={{ width: "100%" }} margin="normal" />
          </div>
          <div className="form-group col-md">
            <TextField label="Phone Number"  type="tel"   id="number" variant="outlined" placeholder="Phone Number"  style={{ width: "100%" }} margin="normal" />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group col-md">
            <TextField label="Subject" type="text" id="subject" variant="outlined" placeholder="Subject" style={{ width: "100%" }} margin="normal" />
          </div>
        </div>

        <div className="form-group">
          <TextField required label="Message" id="message" multiline rows={4} variant="outlined" placeholder="Message" style={{ width: "100%" }} margin="normal" />
        </div>

        <div className="pc-contact__submit-wrap">
          <Button variant="contained" size="large" type="submit" endIcon={<Send />}>
            Send Message
          </Button>
        </div>
      </form>
    </section>
  );
}
